import { reviews, siteName } from '@/mocks/manga';

const principles = [
  {
    icon: 'ri-compass-3-line',
    title: '题材清晰',
    desc: '以女神系题材为核心，分类严谨清晰，让读者能按喜好快速定位。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '品质优先',
    desc: '只推荐有口碑、有亮点的作品，编辑用心筛选每一部入选内容。',
  },
  {
    icon: 'ri-archive-line',
    title: '持续更新',
    desc: '紧跟人气与新作动态，定期补充推荐与专题，保持内容鲜活。',
  },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-vip-crown-2-fill" />
            关于我们
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {siteName}，为女神系漫画而生
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            {siteName} 是一处专注于女神系漫画的在线阅读推荐与分类导航门户。我们相信，每一个以女神为主角的故事，都值得被认真对待、被用心整理。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            从神话传说的恢弘，到降临人间的温情，再到成长与养成的蜕变，我们希望用清晰的分类和真诚的推荐，让每位读者都能在这里找到想看的作品，开启一段与"女神"的奇妙邂逅。
          </p>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-lg`} />
                </span>
                <h3 className="mt-3 font-heading text-sm font-bold text-foreground-900">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-heading text-lg font-bold text-foreground-950">读者口碑</h3>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {reviews.map((r) => (
              <figure
                key={r.name}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-2 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <img
                    src={r.avatar}
                    alt={`${r.name} 的头像`}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{r.name}</span>
                    <span className="block text-xs text-foreground-500">{r.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}